module.exports = __webpack_public_path__ + "static/img/homeicon.ceeb4411.png";